var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.899,
    height: 23.899,
    viewBox: "0 0 23.899 23.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Plus",
    "data-name": "Iconly/Bulk/Plus",
    transform: "translate(-2.759 -2.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(2.759 2.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34200",
    d: "M17.526,0H6.373C2.3,0,0,2.3,0,6.373V17.526C0,21.583,2.294,23.9,6.373,23.9H17.526c4.068,0,6.373-2.316,6.373-6.373V6.373C23.9,2.3,21.594,0,17.526,0Z",
    fill: "#2172e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34201",
    d: "M8.748,5.626H5.675V8.672a.9.9,0,0,1-1.791,0V5.626H.812a.9.9,0,0,1,0-1.785H3.875V.8a.906.906,0,0,1,1.8,0V3.841H8.748a.9.9,0,0,1,0,1.785Z",
    transform: "translate(7.17 7.17)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ebe130f27891d72613ed580b83eb10af.svg";
export { ForwardRef as ReactComponent };